export default __webpack_public_path__ + "static/media/girl.20a5e363.png";